import { generic } from '@sopheos/orbjs_lang';
import reasonsData from '../../assets/lang/report_reasons.json';

export default generic(reasonsData);
